import posthog from 'posthog-js';

export const initializePostHog = (apiKey: string): void => {
  posthog.init(apiKey, {
    api_host: 'https://eu.i.posthog.com',
    defaults: '2025-05-24',
  });
};

export const sendPostHogEvent = (
  event: string,
  properties?: Record<string, any>
): void => {
  if (posthog.__loaded) {
    posthog.capture(`mm_${event}`, {
      ...properties,
      timestamp: new Date().toISOString(),
    });
  }
};

export const registerSuperProperties = (properties: Record<string, any>): void => {
  if (posthog.__loaded) {
    posthog.register(properties);
  }
}

export const unregisterSuperProperty = (property: string): void => {
  if (posthog.__loaded) {
    posthog.unregister(property);
  }
}
